import type { FC } from "react";
import { useEffect } from "react";

import UserCommunicationTemplate from "@/src/common/UserCommunicationTemplate";

import type { INavigationModalActions } from "../common/NavigationModal";
import type { ICashbackClaimFields } from "./CashbackCommonInterfaces";

export type ICashbackClaimWrongDate = INavigationModalActions<ICashbackClaimFields>;

export const CashbackClaimWrongDate: FC<ICashbackClaimWrongDate> = ({
    fieldValues,
    onSubmit,
    previousPage,
    onExit,
}) => {
    useEffect(() => {
        if ((!fieldValues || !fieldValues.communicationTemplate) && onSubmit) {
            onSubmit();
        }
    }, []);

    // Do not override this function calls, to let Navigation Modal handle the flow and function data injection
    // DPPRD-46049 / DPPRD-45802
    const sub = () => onSubmit && onSubmit();
    const prev = () => previousPage && previousPage();
    const close = () => onExit && onExit();

    return fieldValues && fieldValues.communicationTemplate ? (
        <UserCommunicationTemplate
            {...fieldValues.communicationTemplate}
            onExit={close}
            onNext={sub}
            onBack={prev}
        />
    ) : null;
};
